export const formatDate = (fullDate) => {
    if (!fullDate) return 'N/A';

    const date = new Date(fullDate);

    const formattedDate = date.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    }).replace(/\//g, '.');

    return formattedDate;
};

export const formatTime = (fullDate) => {
    if (!fullDate) return 'N/A'

    const date = new Date(fullDate);

    const formattedTime = date.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    });

    return formattedTime
}
